var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2076 2.45526C22.0914 2.35492 21.95 2.28819 21.7987 2.26225C21.6474 2.23631 21.4919 2.25216 21.3489 2.30807L2.34949 9.74339C2.08023 9.84809 1.85226 10.0374 1.69992 10.2829C1.54758 10.5284 1.4791 10.8167 1.5048 11.1045C1.5305 11.3922 1.64898 11.6638 1.84241 11.8784C2.03584 12.093 2.29375 12.239 2.5773 12.2943L7.50011 13.2609V18.75C7.49915 19.0489 7.588 19.3413 7.75515 19.5892C7.92231 19.8371 8.16007 20.0291 8.43761 20.1403C8.71473 20.2534 9.01949 20.2806 9.31225 20.2182C9.60501 20.1559 9.87224 20.0068 10.0792 19.7906L12.4529 17.3287L16.2189 20.625C16.4906 20.866 16.841 20.9993 17.2042 21C17.3633 20.9998 17.5215 20.9748 17.6729 20.9259C17.9204 20.8474 18.1429 20.7054 18.3184 20.5141C18.494 20.3228 18.6163 20.0889 18.6732 19.8356L22.4786 3.2812C22.5126 3.1319 22.5054 2.97616 22.4576 2.83066C22.4099 2.68516 22.3235 2.55539 22.2076 2.45526ZM16.4757 5.83026L8.07668 11.8453L3.42668 10.9331L16.4757 5.83026ZM9.00011 18.75V14.2987L11.3242 16.3368L9.00011 18.75ZM17.2061 19.5L9.4548 12.7031L20.6111 4.70714L17.2061 19.5Z",
    fill: "#0D0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/TelegramLogo.ec8a52db0462b7dd276c4868e0c2f02f.svg";
export { ForwardRef as ReactComponent };